import React from "react";
import { Flex } from "@UI/Components/Flex/Flex";
import { VStack } from "@UI/Components/Stack/Stack";
import { Button } from "@UI/Components/Button/Button";
import { CircleCheck } from "@UI/Components/Icons/CircleCheck";
import { Icon } from "@UI/Components/Icon/Icon";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { Text } from "@UI/Components/Text/Text";
import { useNavigate } from "@Libs/Router/hooks/useNavigate";

export const OrderPaid = () => {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate("HOME", {
      reload: true,
    });
  };

  return (
    <VStack justifyContent="center" spacing="4" pb={{ base: 2, md: 9 }}>
      <Flex textAlign="center">
        <Icon as={CircleCheck} w="12" h="12" color="success" />
      </Flex>

      <Flex textAlign="center">
        <Text>
          <FormattedMessage {...messages.ordePaidMessage} />
        </Text>
      </Flex>
      <Button
        w="full"
        variant="outline"
        onClick={handleConfirm}
        size="lg"
        colorScheme="seaGreen"
        data-testid="complete-subscription"
      >
        <FormattedMessage {...messages.mydashboard} />
      </Button>
    </VStack>
  );
};
